import { CLIENT_URL, SERVER_URL } from '@shared/config/api/api';

import { DownloadFilesReq } from '../model/types/donwloadFilesReq';
import { ProductPageData, ProductPageDataRequest } from '../model/types/productPageData';

export const getProductData = async ({ id, slug }: ProductPageDataRequest): Promise<ProductPageData> => {
  const response = await fetch(`${SERVER_URL}/products/${id}/${slug}/`, {
    next: { revalidate: 0 }
  });

  if (!response.ok) {
    throw new Error(`Product not found: ${id}/${slug}`);
  }

  const data = await response.json();

  if (!data?.product) {
    throw new Error(`Product payload is empty: ${id}/${slug}`);
  }

  return data;
};

export const downloadSelectedFiles = async (body: DownloadFilesReq) => {
  const response = await fetch(`${CLIENT_URL}/product-files/download`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify(body)
  });

  return await response.blob();
};
